import React, { useState } from 'react'
import { Tree, Empty } from 'antd'
import { BookOutlined } from '@ant-design/icons'
import './CategoryTree.css'

function CategoryTree({ categories = [], selectedCategory = '', onSelect }) {
  // 将分类数据转换为树形结构
  const transformCategories = (categories) => {
    const categoryMap = new Map()
    const rootCategories = []
    
    // 创建映射
    categories.forEach(category => {
      categoryMap.set(category.id, {
        ...category,
        key: category.id.toString(),
        title: `${category.name} (${category.book_count || 0})`,
        icon: <BookOutlined />,
        children: []
      })
    })
    
    // 构建树形结构
    categories.forEach(category => {
      const node = categoryMap.get(category.id)
      if (category.parent_id === null) {
        rootCategories.push(node)
      } else {
        const parent = categoryMap.get(category.parent_id)
        if (parent) {
          parent.children.push(node)
        }
      }
    })
    
    return rootCategories
  }
  
  const treeData = transformCategories(categories)
  
  // 处理节点选择
  const handleSelect = (selectedKeys, info) => {
    if (selectedKeys.length > 0) {
      const selectedNode = info.selectedNodes[0]
      if (selectedNode) {
        onSelect(selectedNode.path)
      }
    } else {
      onSelect('')
    }
  }
  
  // 展开所有节点
  const getAllExpandedKeys = (nodes) => {
    const keys = []
    const traverse = (nodeList) => {
      nodeList.forEach(node => {
        keys.push(node.key)
        if (node.children && node.children.length > 0) {
          traverse(node.children)
        }
      })
    }
    traverse(nodes)
    return keys
  }
  
  const expandedKeys = getAllExpandedKeys(treeData)
  
  if (categories.length === 0) {
    return (
      <Empty
        description="暂无分类数据"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
      />
    )
  }
  
  return (
    <Tree
      className="category-tree"
      treeData={treeData}
      selectedKeys={selectedCategory ? [selectedCategory] : []}
      expandedKeys={expandedKeys}
      onSelect={handleSelect}
      defaultExpandAll
      showIcon
    />
  )
}

export default CategoryTree